<template>
  <div id="mine">
    <div class="block-wrap info-box">
      <div class="info-body">
        <div class="avatar">
          <van-image
              width="75"
              height="75"
              round
              fit="contain"
              :src="user.uuid?getAvatarByUUID(user.uuid):''"
          />
        </div>
        <div class="info-content">
          <div class="switch-roles flex-between y-center" @click="onShowRoles">
            <span>{{user.roleName}}</span>
            <van-icon class="iconfont" class-prefix="icon" name="qiehuan" color="#ffffff" size="16px"/>
          </div>
          <p class="name">{{user.userName}}</p>
          <div class="dept">
            <span class="dept-item">{{user.unitName}}</span>
          </div>
          <div class="my-deposits flex-row y-center" @click="toggleDeposits" v-if="assets.length > 1">
            <span>我的资产</span>
            <van-icon class="iconfont" class-prefix="icon" name="yanjing_dakai" color="#ffffff" size="16px" v-if="!viewDeposits"/>
            <van-icon class="iconfont" class-prefix="icon" name="yanjing_guanbi" color="#ffffff" size="16px" v-else/>
          </div>
          <div class="my-deposits flex-row y-center" @click="toggleDeposits" v-if="assets.length === 1">
            <span>{{ assets[0].title }}</span>
            <span class="deposits-item-num" v-if="viewDeposits">{{ assets[0].val+`（`+assets[0].unit+`）` }}</span>
            <span class="deposits-item-num" v-else>****</span>
            <van-icon class="iconfont" class-prefix="icon" name="yanjing_dakai" color="#ffffff" size="16px" v-if="!viewDeposits"/>
            <van-icon class="iconfont" class-prefix="icon" name="yanjing_guanbi" color="#ffffff" size="16px" v-else/>
          </div>
        </div>
      </div>
      <div class="deposits flex-around" v-if="assets.length > 1">
        <div class="deposits-item" v-for="(item,index) in assets" :key="index">
          <span class="deposits-item-name">{{item.title+`（`+item.unit+`）`}}</span>
          <span class="deposits-item-num" v-if="viewDeposits">{{ item.val }}</span>
          <span class="deposits-item-num" v-else>****</span>
        </div>
      </div>
    </div>
    <div class="block-wrap mine-workbench">
      <div class="box bg-white">
        <div class="box-head">
          <p class="box-name">我的工作台</p>
          <span class="goto" @click="gotoMyItems">更多</span>
        </div>
        <div class="box-body">
          <div class="flex-around my-items">
            <router-link class="my-item flex-column center" tag="div" :to="{name: 'MY_ITEMS', params: {type: 'receive'}, text: '我收到的'}">
              <span class="my-item-num">{{ sumtodo }}</span>
              <span class="my-item-name">我收到的</span>
            </router-link>
            <router-link class="my-item flex-column center" tag="div" :to="{name: 'MY_ITEMS', params: {type: 'send'}, text: '我发出的'}">
              <span class="my-item-num">{{ sumongoing }}</span>
              <span class="my-item-name">我发出的</span>
            </router-link>
            <router-link class="my-item flex-column center" tag="div" :to="{name: 'MY_TRANSFER',text: '我转办的'}">
              <span class="my-item-num">{{ sumShuffl }}</span>
              <span class="my-item-name">我转办的</span>
            </router-link>
          </div>
        </div>
        <svg class="mine-animation"
             xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             viewBox="0 24 150 28"
             preserveAspectRatio="none">
          <defs>
            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
          </defs>
          <g class="parallax">
            <use xlink:href="#gentle-wave" x="50" y="0" fill="var(--main-color)"/>
            <use xlink:href="#gentle-wave" x="50" y="3" fill="var(--main-color)"/>
          </g>
        </svg>
      </div>
    </div>
    <div class="block-wrap mine-common">
      <div class="box bg-white">
        <div class="box-head">
          <p class="box-name">我的常用</p>
        </div>
        <div class="box-body">
          <ServiceItemPortraitLineOne v-for="(item,index) in commonServices.slice(0,commonServicesViewSize)" :key="index" :service="item"/>
        </div>
      </div>
    </div>
    <div class="block-wrap cells">
      <div class="box bg-white ">
        <van-cell v-for="(item,index) in menus"
            :title="item.configName.length>10?item.configName.slice(0,10) + '...' : item.configName"
            :icon="complete(item.icon)"
            is-link
            @click="redirect(item)"
            :key="index"></van-cell>
      </div>
    </div>
    <van-action-sheet
        v-model="showRoles"
        :actions="rolesActions"
        cancel-text="取消"
        @cancel="onCancelRoles"
        @select="onSelectRoles"
    />
  </div>
</template>

<script>
import {Image,ActionSheet,Toast,Cell} from 'vant';
import {locationTo,complete} from "@/utils/url"
import {queryCommonService, queryMenu, queryMineAssets, queryRoles, switchRoles} from "@/api/mine";
import {queryTotalItemNum} from "@/api/my-items";
import {queryUserLogin} from "@/api";
import {getAvatarByUUID} from "@/utils/commons";

export default {
  name: "Mine",
  components: {
    ServiceItemPortraitLineOne: () => import("@/components/ServiceHall/ServiceItemPortraitLineOne"),
    [Image.name]: Image,
    [ActionSheet.name]:ActionSheet,
    [Cell.name]:Cell
  },
  data() {
    return {
      viewDeposits:false,
      assets:[],
      showRoles:false,
      rolesActions:[],
      exampleAvatar: require("@/assets/image/user.png"),
      sumtodo: 0,
      sumongoing: 0,
      sumShuffl:0,
      commonServices: [],
      commonServicesViewSize:8,
      menus:[],
      user:{}
    };
  },
  computed: {
  },
  created() {
    this.refreshUser();
    this.init();
  },
  methods: {
    init() {
      this.rolesActions = [];
      queryRoles().then(resp=>{
        if (resp.code && resp.code == 200) {
          if(resp.data){
            resp.data.forEach(item=>{
              this.rolesActions.push({id:item.id,name:item.roleName});
            });
          }
        }
      });
      queryMineAssets().then(resp=>{
        if(resp.code != 200){
          Toast(resp.message);
        }
        if(resp.data){
          this.parseMineAssets(resp.data);
        }
      })
      queryTotalItemNum().then(resp => {
        if(resp){
          this.sumtodo = resp.sumtodo?this.parseNum(resp.sumtodo):0;
          this.sumongoing = resp.sumongoing?this.parseNum(resp.sumongoing):0;
          this.sumShuffl = resp.sumShuffl?this.parseNum(resp.sumShuffl):0;
        }
      });
      queryCommonService(this.commonServicesViewSize).then(resp => {
          if(resp && resp.data){
              this.commonServices = resp.data;
          }
      });
      queryMenu().then(resp => {
        if(resp.code && resp.code != 200){
          Toast(resp.message)
          return
        }
        this.menus = resp.data;
      });
    },
    getUser(){
      let storage = JSON.parse(sessionStorage.getItem("current-login-user"));
      if(storage){
        this.user = storage;
        return true
      }
      this.refreshUser();
    },
    refreshUser(){
      queryUserLogin().then(user=>{
        if(user.data){
          this.user = user.data;
          sessionStorage.setItem("current-login-user",JSON.stringify(user.data));
        }
      });
    },
    //显示隐藏我的资产
    toggleDeposits(){
      this.viewDeposits = !this.viewDeposits;
    },
    logout() {
      this.$store.commit('logout')
    },
    onShowRoles(){
      this.showRoles = true;
    },
    onSelectRoles(item){
      switchRoles(item.id).then(resp=>{
        if(resp.code && resp.code != '200'){
          Toast("切换角色失败");
          return false;
        }
        Toast("切换角色成功");
        this.refreshUser();
        this.init();
      }).finally(()=>{
        this.showRoles = false;
      });
    },
    onCancelRoles(){
      this.showRoles = false;
    },
    gotoMyItems(){
      this.$router.push('/homeTab/myItems/receive');
    },
    redirect(item){
      if(item.urlType == '0'){
        this.$router.push(item.url);
      }else{
        this.locationTo(item.url);
      }
    },
    parseNum(num) {
      if (!num) return num
      if (typeof num == 'string') num = parseInt(num)
      if (num > 9999) num = '9999+'
      return num
    },
    parseMineAssets(e){
      //解析我的资产
      try {
        let data = e.config.data&&e.config.data.length>0?e.config.data:[];
        let vals = e.data;
        let assets = [];
        data.forEach(i=>{
          let item = i;
          if(vals.hasOwnProperty(i.dataId)){
            let val = Number(vals[i.dataId].data);
            item.val = val.toFixed(2);
            assets.push(item);
          }
        });
        this.assets = [];
        this.assets = assets.slice(0,3);
      }catch (err) {
        console.warn(err)
      }
    },
    getAvatarByUUID,locationTo,complete
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
.block-wrap {
  padding: 0 15px 15px;
}

.box {
  padding: 20px 8px;
  border-radius: 5px;

  .box-head {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .box-name {
      color: #333;
      @extend .font16;
    }

    .goto {
      color: #999;
      @extend .font13;
    }
  }
}
.bg-white {
  background: #fff;
}

.info-box {
  position: relative;
  padding-top:15px;
  color: #fff;
  background-color: var(--main-color);
  @extend .font13;
  .info-body {
    display: flex;
    flex-direction: row;
    align-items: stretch;

    .info-content {
      padding-left: 10px;
      padding-top: 5px;
      flex:1;

      .switch-roles{
        position: absolute;
        top: 18px;
        right: 0;
        height: 28px;
        padding-left: 10px;
        border-top-left-radius: 14px;
        border-bottom-left-radius: 14px;
        background: rgba(255, 255, 255, .1);

        .van-icon{
          margin:0 4px;
        }
      }
      .name {
        margin-bottom: 8px;
        font-weight: bold;
        line-height: 1.2;
        @extend .font18;
      }

      .dept {
        padding-right: 80px;

        .dept-item {
          display: inline-block;
          padding: 0 10px;
          border-radius: 10px;
          line-height: 20px;
          background: rgba(255, 255, 255, .1);
        }
      }

      .my-deposits {
        margin-top: 6px;
        .deposits-item-num{
          padding-left:5px;
        }
        .icon {
          margin-left: 12px;
        }
      }

    }
  }
}
.deposits {
  margin-top: 30px;
  @extend .font13;
  background: inherit;

  .deposits-item {
    background: inherit;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    text-align: center;

    .deposits-item-name {
      @extend .font13;
      opacity: .6;
    }

    .deposits-item-num {
      margin-top: 12px;
      @extend .font18;
    }
  }
}
.mine-workbench{
  position: relative;
  z-index:0;

  &::after{
    position: absolute;
    left: -10%;
    top: 0;
    z-index:1;
    width: 120%;
    height: 80px;
    content: '';
    border-radius: 0 0 50% 50%;
    background-color: var(--main-color);
  }

  .box {
    position: relative;
    z-index:2;
    overflow: hidden;
    .box-body{
      position: relative;
      z-index:3;
    }
    .my-items {
      .my-item {
        .my-item-name {
          margin-top: 12px;
          @extend .font14;
        }

        .my-item-num {
          @extend .font18;
          color: var(--main-color);
        }
      }
    }
    svg.mine-animation {
      position: absolute;
      left: 0;
      bottom: 0;
      display: block;
      width: 100%;
      z-index:1;
      .parallax {

        use {
          opacity: .05;
          -webkit-animation: move-forever 12s linear infinite;
          -o-animation: move-forever 12s linear infinite;
          animation: move-forever 12s linear infinite;

          &:nth-child(1) {
            animation-delay: -2s;
          }

          &:nth-child(2) {
            animation-delay: -2s;
            animation-duration: 5s;
          }
        }

        @-webkit-keyframes move-forever {
          0% {
            -webkit-transform: translate(-90px, 0%);
          }
          100% {
            -webkit-transform: translate(85px, 0%);
          }
        }

        @-moz-keyframes move-forever {
          0% {
            -moz-transform: translate(-90px, 0%);
          }
          100% {
            -moz-transform: translate(85px, 0%);
          }
        }

        @-ms-keyframes move-forever {
          0% {
            -ms-transform: translate(-90px, 0%);
          }
          100% {
            -ms-transform: translate(85px, 0%);
          }
        }

        @-o-keyframes move-forever {
          0% {
            -o-transform: translate(-90px, 0%);
          }
          100% {
            -o-transform: translate(85px, 0%);
          }
        }

        @keyframes move-forever {
          0% {
            transform: translate(-90px, 0%);
          }
          100% {
            transform: translate(85px, 0%);
          }
        }
      }
    }
  }
}
.mine-common {
  .box {
    .box-head {
      margin-bottom: 0;
    }

    .box-body {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(4, 25%);
      align-items: start;

      .service-item-portrait {
        overflow: hidden;

        .service-name {
          width: 25px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
        }
      }
    }
  }
}
.cells {
  padding-bottom: 12px;

  .box {
    padding: 8px 15px;
  }

  .van-cell{
    display: flex;
    padding: 15px 0;
    align-items: center;
    align-content: center;
    flex-direction: row;
    justify-content: center;

    .van-icon__image {
      width: 18px;
      height: 18px;
    }

    .van-cell__left-icon,
    .van-cell__right-icon {
      line-height: unset;
      display: flex;
      align-items: center;
      align-content: center;
      flex-direction: row;
      justify-content: center;
    }

    .van-cell__left-icon {
      margin-right: 15px;
    }

    .van-cell__title {
      span {
        @extend .font14;
      }
    }

    &:after {
      left: 0;
      right: 0;
    }
  }
}
.roles-list {
  padding:15px;

  .roles-item{
    height: 26px;
    width: 100%;
    border-radius: 13px;
    line-height:1;
  }
}
</style>
